// extracted by mini-css-extract-plugin
export default {"decisionSection":"FormCmprQuote_decisionSection__s0-8Q"};